import { gql } from "@apollo/client";

export const PERSON_FIELDS_FRAGMENT = gql`
  fragment PersonFields on PersonRepresentation {
    id
    picture
    lastName
    firstName
    gender
    dateOfBirth
    email
    phoneNumber {
      indicative
      number
    }
    governmentIDNumber
    type
    status
  }
`;
